import {usePageLoading} from '@/Components/Common/Providers/PageLoadingProvider.jsx';
import Footer from '@/Components/Layouts/Footer.jsx';
import Header from '@/Components/Layouts/Header.jsx';
import AuthenticatedMenu from '@/Components/Menus/Main/AuthenticatedMenu.jsx';
import GuestMenu from '@/Components/Menus/Main/GuestMenu.jsx';
import {usePage} from '@inertiajs/react';
import {Backdrop, Box, CircularProgress} from '@mui/material';
import * as React from 'react';
import {memo} from 'react';

const MainLayout = ({children}) => {
    const {auth, layout} = usePage().props;
    const hideLayout = layout && layout === '0';
    const {page_loading} = usePageLoading();

    return (
        <>
            <Header>{auth?.user ? <AuthenticatedMenu /> : <GuestMenu />}</Header>
            <Box id="content" component="main">
                {children}
            </Box>
            {!hideLayout && <Footer />}
            <Backdrop sx={{color: 'white', zIndex: (theme) => theme.zIndex.drawer + 1}} open={page_loading}>
                <CircularProgress color="inherit" />
            </Backdrop>
        </>
    );
};
export default memo(MainLayout);
